import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';
import WithAjax from 'static/script/app/data/with-ajax';
import StorageFactory from 'static/script/app/data/storage-factory';
import MegaCategories from 'static/script/app/ui/mega-categories';

function MegaMenuUI() {
    this.defaultAttrs({
        template: '[data-template-mega-menu]',
        megaMenuSelector: '[data-start-page-mega-categories]',
        header: '[data-site-header]',
        initData: null
    });

    this._toggleMegaMenu = function () {
        let megaMenu = this.select('megaMenuSelector');
        if (this.attr.initData.pageName === 'StartPage') {
            if (megaMenu.length < 1) {
                this._loadMegaMenu();
            }
        } else {
            if (megaMenu.length > 0) {
                megaMenu.remove();
            }
        }
    };

    this._loadMegaMenu = function () {

        let cached = this._dataStore.get('mega-menu');
        if (cached) {
            this._addToHeader(cached);
            return;
        }

        this._get({
            url: '/StartPage/MegaCategories',
            type: 'text/html',
            dataType: 'html'
        })
            .done(this._addToHeader.bind(this))
            .done(this._addToCache.bind(this));
    };

    this._addToHeader = function (html) {
        this.select('header').after(html);
        MegaCategories.attachTo(this.attr.megaMenuSelector);
    };

    this._addToCache = function (html) {
        this._dataStore.set('mega-menu', html);
    };

    this.after('initialize', function () {
        this._dataStore = StorageFactory.session();

        let megaMenu = this.select('megaMenuSelector');
        if (megaMenu.length > 0) {
            this._addToCache(megaMenu[0].outerHTML);
        }

        this.on(document, 'ui:navigation:after-page-change', this._toggleMegaMenu);
    });
}

export default defineComponent.component(MegaMenuUI, WithAjax);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/mega-menu-ui.js